import Vue from 'vue'

import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'
import VueI18n from 'vue-i18n'
import VueSocketIO from 'vue-socket.io'
import SocketIO from 'socket.io-client'

import Config from '../config'

import vuetify from '@/libs/vuetify' // path to vuetify export

import messages from './lang'
import router from './router'
import store from './store'
import App from './App.vue'

// Global Components
import './global-components'

// 3rd party plugins
import '@/libs/portal-vue'
import '@/libs/toastification'

import { func } from '@/func'

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)
Vue.use(VueI18n)

// Composition API
Vue.use(VueCompositionAPI)

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')
// Global functions
Vue.prototype.$functions = func

Vue.config.productionTip = false

Vue.use(VueI18n)
let defaultLanguage = 'fa'

// بررسی اینکه قبلا چه زبانی را انتخاب کرده است و همان انتخاب شود
const locale = localStorage.getItem('locale')
if (locale in messages) {
  defaultLanguage = localStorage.getItem('locale')
}
if (localStorage.getItem('user'))
{ Vue.prototype.$isAdmin = JSON.parse(localStorage.getItem('user')).isAdmin }
Vue.prototype.$isUser = true

// Platforms = android, iphone, web
Vue.prototype.$productionPlatform = Config.productionPlatform

export const i18n = new VueI18n({
  locale: defaultLanguage,
  fallbackLocale: defaultLanguage,
  messages,
})

new Vue({
  sockets: {
    connect() {
      console.log('Socket connected.')
    },
  },
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App),
}).$mount('#app')
